<template>
    <div :class="['d-flex', 'search-container', {'mode-1': mode}, 'w-100']">
        <form class="search-container-form" @submit.prevent="changeSiteRouteForFilter">
            <input v-if="allowTextSearch" v-model="textSearchValue" name="search-input" pattern="[\p{L} ]*" title="გთხოვთ შეიყვანოთ მხოლოდ სიმბოლოები" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
            <h6 v-if="allowFiltersTitle" class="extra-light-text light-black-color" id="assist">ფილტრები:</h6>
            <fieldset class="filters-wrapper">
                <input v-if="allowDateInput" v-model="dateInputValue" pattern="^(\d{4}-\d{2}-\d{2})$" class="primary-date-input" name="date" id="date" type="date" placeholder="თარიღი">
                <Multiselect v-for="(data, i) of localeMultiselectArray" v-model="data.Vmodel" :options="data.options" :mode="data.mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                    :hideSelected="true" @select="(value, option) => allowNextMultiselect(value, option, i)" @deselect="() => blockNextMultiselects(i)"
                    @clear="() => blockNextMultiselects(i)"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                    
                    <!-- :regex -->

                <!-- <p>{{ testModel }}</p>
                <Multiselect class="extra-light-text light-blue-color" placeholder="ქალაქი" v-model="testModel" :options="testOptions"/>
                <Multiselect class="extra-light-text light-blue-color" placeholder="უბანი"/> -->
            </fieldset>
            <button type="submit" class="extra-light-text extra-green-color" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
            <!-- <p>{{ this.multiselectArray[0].placeholder }}</p>
            <p>{{ this.multiselectArray[0].Vmodel }}</p> -->
        </form>
        <primaryButtonComponent v-if="allowExportButton" class="excel-export-button" buttonWidth="fit-content" paddingX="15px" paddingY="7px">
            <template v-slot:content>
                <div class="d-flex gap-2 align-items-center">
                    <p class="extra-light-text font-weight-600">ექსპორტი</p>
                    <img src="@/assets/images/excelExportImage.svg" alt="">
                </div>
            </template>
        </primaryButtonComponent>
    </div>
</template>
<script>
import Multiselect from '@vueform/multiselect'
import primaryButtonComponent from './primaryButtonComponent.vue';
import { isProxy, toRaw } from 'vue';

export default {
    data(){
        return {
            // testModel: null,
            // testOptions: [
            //     {
            //         value: "1",
            //         label: "tbilisi",
            //     },
            //     {
            //         value: "2",
            //         label: "gurjaani",
            //     }
            // ]
            localeMultiselectArray: [],
            textSearchValue: "",
            dateInputValue: "",
        }
    },
    components: {
        Multiselect,
        primaryButtonComponent,
    },
    props: {
        mode: {
            type: Boolean,
            default: false,
        },
        allowFiltersTitle: {
            type: Boolean,
            default: true,
        },
        allowExportButton: {
            type: Boolean,
            default: true,
        },
        allowTextSearch: {
            type: Boolean,
            default: true,
        },
        textSearchSendName: String,
        allowDateInput: {
            type: Boolean,
            default: true,
        },
        dateInputSendName: String,
        multiselectArray: {
            type: Array,
            default: [],
        }
    },
    mounted(){
        this.getLocaleMultiselectArray();
    },
    methods: {
        getLocaleMultiselectArray(){
            this.localeMultiselectArray = this.multiselectArray;
        },
        allowNextMultiselect(value, option, index){
            if(index < this.localeMultiselectArray.length - 1){
                if(this.localeMultiselectArray[index].dependancyArray.length > 0){
                    for(let dependancyObj of this.localeMultiselectArray[index].dependancyArray){
                        this.localeMultiselectArray[index + 1].dependancyArray.push(dependancyObj);
                    }
                }
                this.localeMultiselectArray[index + 1].dependancyArray.push({
                    value: option.value,
                    label: option.label,
                    sendName: this.localeMultiselectArray[index].sendName,
                });
                this.localeMultiselectArray[index + 1].isDisabled = false;
            }
            
        },
        blockNextMultiselects(index){
            if(index >= this.localeMultiselectArray.length - 1){
                
                return;
            }
            this.localeMultiselectArray[index + 1].Vmodel = null;
            // this.localeMultiselectArray[index + 1].options = [];
            this.localeMultiselectArray[index + 1].dependancyArray = [];
            this.localeMultiselectArray[index + 1].isDisabled = true;
            this.blockNextMultiselects(index + 1);
        },
        checkTextInputWithRegex(){
            const regexTest = new RegExp("[^\\p{L} ]", "u");
            let result = regexTest.test(this.textSearchValue);
            
            return result;
        },
        checkDateWithRegex(){
            const regexTest = new RegExp("(^(\\d{4}-\\d{2}-\\d{2})$)|");
            let result = regexTest.test(this.dateInputValue);
            return result;
        },
        isValid(value){
            if(value == "" || value == null || value == undefined){
                return false;
            }
            return true;
        },
        changeSiteRouteForFilter(){
            let tempQuery = {};
            if(this.allowTextSearch){
                if(!this.checkTextInputWithRegex()){
                    if(this.isValid(this.textSearchValue)){
                        tempQuery[this.textSearchSendName] = this.textSearchValue.length > 0?this.textSearchValue:null;
                    }
                }else{
                    return;
                }
            }
            if(this.allowDateInput){
                if(this.checkDateWithRegex()){
                    if(this.isValid(this.dateInputValue)){
                        tempQuery[this.dateInputSendName] = this.dateInputValue.length > 0?this.dateInputValue:null;
                    }
                }else{
                    return;
                }
            }
            for(let multiselectObj of this.localeMultiselectArray){
                if(this.isValid(multiselectObj.Vmodel)){
                    tempQuery[multiselectObj.sendName] = multiselectObj.Vmodel;
                }
            }
            this.$router.push({
                path: this.$route.path,
                query: {...tempQuery},
            });
        },
    }
}
</script>
<style scoped>
.search-container{
    justify-content: space-between;
    align-items: center;
    background-color: var(--secondary-background-color);
    border-radius: 10px;
    padding: 15px;
    column-gap: 3em;
}
.search-container-form{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
}
.search-container.mode-1 .primary-input{
    max-width: 520px;
}
.search-container-form .filters-wrapper{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: end;
    gap: 15px;
}
.search-container-form .filters-wrapper .multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
.search-container-form > h6{
    font-weight: 600;
}
@media screen and (max-width: 1800px) {
    .search-container{
        justify-content: space-between;
        align-items: flex-start;
    }
    .search-container.mode-1 .primary-input{
        max-width: 400px;
    }
    .search-container:not(.mode-1) .search-container-form{
        flex-direction: column;
        justify-content: start;
        align-items: start;
    }
    .search-container-form > h6, .excel-export-button{
        margin: 0;
    }
    .search-container:not(.mode-1) .search-container-form .filters-wrapper{
        flex-wrap: wrap;
        justify-content: start;
    }
    .search-container-form .filters-wrapper .multiselect{
        min-width: 180px;
    }
}
@media screen and (max-width: 1560px) {
    .search-container.mode-1 .primary-input{
        max-width: 300px;
    }
}
</style>